module.exports = __webpack_public_path__ + "img/view-all.54ae8ce5.svg";